import React from "react";
import { useAppContext } from "../context/AppContext";

const countryCycle = ["RU", "IL", "OTHER"];

const getFlag = (country) => {
  switch (country) {
    case "RU":
      return "🇷🇺";
    case "IL":
      return "🇮🇱";
    default:
      return "🌍";
  }
};

const getCountryName = (country) => {
  switch (country) {
    case "RU":
      return "Russia";
    case "IL":
      return "Israel";
    default:
      return "World";
  }
};

export default function CountryToggler() {
  const { country, setCountry } = useAppContext();

  const toggleCountry = () => {
    const currentIndex = countryCycle.indexOf(country);
    const nextIndex = (currentIndex + 1) % countryCycle.length;
    setCountry(countryCycle[nextIndex]);
  };

  return (
    <button
      onClick={toggleCountry}
      className="rounded text-xl hover:bg-beige transition"
      title={`Текущая страна: ${getCountryName(country)}`}
    >
      {getFlag(country)}
    </button>
  );
}
